import axios from "axios";
const host = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

export async function fetchAnnouncementsApi() {
  const res = await axios.get(`${host}api/dashboard/announcements/`, {
    headers: {
      token,
    },
  });
  // const res = await axios({
  //   url: host + "api/dashboard/announcements/",
  //   method: "GET",
  //   headers: { token: token },
  // });
  return res;
}

export async function deleteAnnouncementApi(values) {
  const res = await axios.delete(
    `${host}api/dashboard/announcements/delete/${values.id}`,
    {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/dashboard/announcements/delete/" + values.id,
  //   method: "DELETE",
  //   headers: { token: token },
  // });
  return res;
}

export async function editAnnouncementApi(obj) {
  const res = await axios.put(
    `${host}api/dashboard/announcements/edit/${obj.id}`,
    obj,
    {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/dashboard/announcements/edit/" + obj.id,
  //   method: "PUT",
  //   headers: { token: token },
  //   data: obj,
  // });
  return res;
}

export async function newAnnouncementApi(values) {
  const res = await axios.post(
    `${host}api/dashboard/announcements/new`,
    values,
    {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/dashboard/announcements/new",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}
export async function newAllDomainsAnnouncementApi(values) {
  const res = await axios.post(
    `${host}api/dashboard/announcements/allDomain`,
    values,
    {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/dashboard/announcements/allDomain",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}
export async function fetchMentorMenteesApi() {
  const res = await axios.get(`${host}api/dashboard/mentorsMentees/`, {
    headers: {
      token,
    },
  });
  // const res = await axios({
  //   url: host + "api/dashboard/mentorsMentees/",
  //   method: "GET",
  //   headers: { token: token },
  // });
  return res;
}

export async function fetchWaLinksApi() {
  const res = await axios.get(`${host}api/dashboard/walinks/`, {
    headers: { token: token },
  });
  // const res = await axios({
  //   url: host + "api/dashboard/walinks/",
  //   method: "GET",
  //   headers: { token: token },
  // });
  return res;
}

export async function fetchContactCardsApi() {
  const res = await axios.get(
    `${host}api/dashboard/mentorsMentees/contactCard`,
    {
      headers: { token: token },
    }
  );
  return res;
}

export async function editWalinkApi(values) {
  const res = await axios.put(
    `${host}api/dashboard/walinks/edit/${values.domainId}`,
    { waLink: values.waLink },
    {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/dashboard/walinks/edit/" + values.domainId,
  //   method: "PUT",
  //   headers: { token: token },
  //   data: { waLink: values.waLink },
  // });
  return res;
}
